import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { BehaviorSubject } from 'rxjs';
import { FormMode } from 'src/app/controls/common/form-mode';
import { IFolderState } from 'src/app/models/interfaces/folder-state.interface';
import { FolderStateDetailContext } from '../folder-state-detail-context';
import { FolderStateFormComponent } from '../folder-state-form/folder-state-form.component';

@Component({
    selector: 'app-folder-state-detail',
    templateUrl: './folder-state-detail.component.html',
    styleUrls: ['./folder-state-detail.component.scss'],
    imports: [MatTabsModule, FolderStateFormComponent]
})
export class FolderStateDetailComponent implements OnInit {
    /**
     * Mode d'affichage du formulaire (consultation / edition / création)
     */
    public FormMode = FormMode;

    /**
     * Reference au composant groupe d'onglets.
     */
    @ViewChild(MatTabGroup)
    tabGroup: MatTabGroup;

    /**
     * Emis lorsque le formulaire est mis à jour (clic sur le bouton sauver)
     */
    @Output()
    public folderStateUpdated: EventEmitter<IFolderState> = new EventEmitter();

    /**
     * Emis lorsque le formulaire est annuler(clic sur le bouton annuler)
     */
    @Output()
    public canceled: EventEmitter<boolean> = new EventEmitter();

    /**
     * Indique si le composant est en mode debug (affiche des informations pour le developpeur)
     */
    public debugMode = false;

    /**
     * Contexte du formulaire.
     */
    public _context: FolderStateDetailContext;

    /**
     * Utilisé pour propager des changements de contexte.
     */
    public _context$: BehaviorSubject<FolderStateDetailContext> = new BehaviorSubject(null);

    /**
     * Appellé par le composant parent pour specifier un nouveau contexte.
     */
    @Input()
    set context(value: FolderStateDetailContext) {
        // set the latest value for _data BehaviorSubject
        this._context$.next(value);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        /**
         * S'abonne aux changements de contexte
         */
        this._context$.subscribe((x) => {
            this._context = x;
        });
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont sauvegardés.
     * @param user: Infos du folderState modifié.
     */
    public onFolderStateUpdated(folderState: IFolderState) {
        this.folderStateUpdated.emit(folderState);
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont annulés.
     * @param user: Infos de l'article modifié.
     */
    public onCanceled(value: boolean) {
        this.canceled.emit(value);
    }
}
